import * as React from "react";

const StopSignIcon = ({ color, ...rest }) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...rest}
	>
		<path
			d="M5.75 5.75L18.25 18.25M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z"
			stroke={color ? color : 'white'}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default StopSignIcon;
